import { render, staticRenderFns } from "./SettingsInputFile.vue?vue&type=template&id=ecb6354e&scoped=true&"
import script from "./SettingsInputFile.vue?vue&type=script&lang=js&"
export * from "./SettingsInputFile.vue?vue&type=script&lang=js&"
import style0 from "./SettingsInputFile.vue?vue&type=style&index=0&id=ecb6354e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb6354e",
  null
  
)

export default component.exports